import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { IShipmentException } from '../../../history/bir/models/shipment-exception.interface';

@Injectable()
export class BirService {

    constructor(private httpClientService: HttpClientService,
                private httpClient: HttpClient,
                private apiEndpointService: ApiEndpointService,
    ) {
    }

    /**
     * Gets BIR Shipment Exceptions.
     *
     * @returns {Observable<any>}
     */
    public getShipmentExceptions(): Observable<IShipmentException[]> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getShipmentExceptions'))
            .toString();
        return this.httpClientService.get<IShipmentException[]>(endpoint);
    }

    /**
     * Update BIR Shipment Date
     *
     * param shipmentId {string}
     * param shipmentDate {string}
     * @returns {Observable<any>}
     */
    public updateShipmentDate(shipmentId: string, shipmentDate: string): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('updateShipmentDate'))
            .toString();

        // for some reason HttpService <put> call content-type is sent as text/pain. So manually interupting the Http Headers below.
        // const options = { headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8') };

        // Note: when using back-ticks (``), we can construct a string with template literals.
        // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
        const data = `{"ShipmentId":"` + shipmentId + `", "ShipDate":"` + shipmentDate + `"}`;

        // return this.httpClient.put<any>(endpoint, data, options);
        return this.httpClientService.put<any>(endpoint, data);
    }

    /**
     * Update BIR Shipment Date
     *
     * param shipmentId {string}
     * @returns {Observable<any>}
     */
    public voidShipment(shipmentId: string): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('voidShipment'))
            .param('shipmentId', shipmentId)
            .toString();

        return this.httpClientService.delete<any>(endpoint);
    }
}
